module.exports = __webpack_public_path__ + "img/bwclockserver.b900831f.svg";